import { forwardRef } from "react";
import { useId } from "react";
function SvgRawCanvasIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id={`RawCanvasIcon_svg__Layer_1${toAppend}`}
      width={24}
      height={24}
      data-name="Layer 1"
      viewBox="0 0 234.98 235.1"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <style>{".RawCanvasIcon_svg__cls-1{fill:#e23e29}"}</style>
      </defs>
      <path
        d="M34.09 117.28A34 34 0 0 0 4.26 83.56a134.93 134.93 0 0 0 0 67.39 34 34 0 0 0 29.83-33.67Z"
        className="RawCanvasIcon_svg__cls-1"
      />
      <circle
        cx={53.83}
        cy={117.28}
        r={10.67}
        className="RawCanvasIcon_svg__cls-1"
      />
      <path
        d="M200.91 117.28a34 34 0 0 0 29.8 33.7 135 135 0 0 0 0-67.4 34 34 0 0 0-29.8 33.7Z"
        className="RawCanvasIcon_svg__cls-1"
      />
      <circle
        cx={181.16}
        cy={117.28}
        r={10.67}
        className="RawCanvasIcon_svg__cls-1"
      />
      <path
        d="M117.28 201a34 34 0 0 0-33.73 29.83 135.2 135.2 0 0 0 67.4 0A34 34 0 0 0 117.28 201ZM117.28 170.61a10.64 10.64 0 1 1-10.64 10.64 10.64 10.64 0 0 1 10.64-10.64ZM117.28 34.1A34 34 0 0 0 151 4.27a135.16 135.16 0 0 0-67.39 0 34 34 0 0 0 33.67 29.83ZM117.28 43.2a10.64 10.64 0 1 1-10.64 10.64 10.63 10.63 0 0 1 10.64-10.64ZM176.37 176.38a34 34 0 0 0-2.78 44.89 134.77 134.77 0 0 0 47.65-47.68 34 34 0 0 0-44.87 2.79ZM154.86 154.85a10.66 10.66 0 1 1 0 15.08 10.66 10.66 0 0 1 0-15.08ZM58.48 58.49a34 34 0 0 0 2.79-45 134.85 134.85 0 0 0-47.76 47.79 34 34 0 0 0 44.97-2.79ZM64.81 64.82a10.67 10.67 0 1 1 0 15.08 10.66 10.66 0 0 1 0-15.08ZM176.29 58.27a34 34 0 0 0 44.86 2.78 134.85 134.85 0 0 0-47.62-47.65 34 34 0 0 0 2.76 44.87ZM154.78 64.69a10.67 10.67 0 1 1 0 15.09 10.67 10.67 0 0 1 0-15.09ZM58.32 176.24a34 34 0 0 0-44.87-2.78 134.83 134.83 0 0 0 47.65 47.67 34 34 0 0 0-2.78-44.89ZM64.76 154.74a10.67 10.67 0 1 1 0 15.08 10.67 10.67 0 0 1 0-15.08Z"
        className="RawCanvasIcon_svg__cls-1"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawCanvasIcon);
export default ForwardRef;
